// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SzL9Ud {
  border: none;
  padding: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: auto;
  width: 400px;
  height: 100vh;
  min-height: 100vh;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s) 0 0 var(--radius-s);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  cursor: default;
  z-index: 1300;
}

.SzL9Ud:focus {
  outline: none;
}

.SzL9Ud::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.SzL9Ud[open] {
  margin: 0;
  height: 100vh;
  min-height: 100vh;
}

.PWl4VW {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1);
  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);
}

.rbygD9 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.sT4mOv {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.XYzh3S {
  width: 16px;
  height: 16px;
}

.VEiNw1 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  background: var(--surface-neutral-white);
  padding: var(--spacing-3);
  gap: var(--spacing-3);
}

.YYgz41 {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-1);
}

.M50uM2 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1-5);
}

.nLMdtg {
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1-5);
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
}

.P3d5uS {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: left;
}

.hhoPcF {
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
}

.nQ6VO9 {
  position: relative;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AccountsPayableFilter/AccountsPayableFilter.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".modal {\n  border: none;\n  padding: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 400px;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s) 0 0 var(--radius-s);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1300;\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.modal[open] {\n  margin: 0;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.chevronLeft {\n  width: 16px;\n  height: 16px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  width: 100%;\n  background: var(--surface-neutral-white);\n  padding: var(--spacing-3);\n  gap: var(--spacing-3);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1-5);\n}\n\n.rowOperations {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1-5);\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.footer {\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n.button {\n  position: relative;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `SzL9Ud`,
	"header": `PWl4VW`,
	"title": `rbygD9`,
	"closeButton": `sT4mOv`,
	"chevronLeft": `XYzh3S`,
	"body": `VEiNw1`,
	"column": `YYgz41`,
	"row": `M50uM2`,
	"rowOperations": `nLMdtg`,
	"label": `P3d5uS`,
	"footer": `hhoPcF`,
	"button": `nQ6VO9`
};
module.exports = ___CSS_LOADER_EXPORT___;
